module.exports = __webpack_public_path__ + "static/media/drop-off-green.7340b2df.svg";